import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconFastForward = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--fast-forward")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M13.6139406,4.21249932 L22.6139406,11.2124993 C23.1286865,11.6128572 23.1286865,12.3908459 22.6139406,12.7912038 L13.6139406,19.7912038 C12.9570826,20.3020933 12,19.8339997 12,19.0018515 L12,5.00185154 C12,4.16970336 12.9570826,3.70160976 13.6139406,4.21249932 Z M2.61394061,4.21249932 L11.6139406,11.2124993 C12.1286865,11.6128572 12.1286865,12.3908459 11.6139406,12.7912038 L2.61394061,19.7912038 C1.95708261,20.3020933 1,19.8339997 1,19.0018515 L1,5.00185154 C1,4.16970336 1.95708261,3.70160976 2.61394061,4.21249932 Z M14,7.0464909 L14,16.9572122 L20.371178,12.0018515 L14,7.0464909 Z M3,7.0464909 L3,16.9572122 L9.37117796,12.0018515 L3,7.0464909 Z" id="icon--centivo--fast-forward"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1456.000000, -523.000000)"/>
          <g id="Icon/fast-forward">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--fast-forward"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--fast-forward"/>
          </g>
      </g>
  </IconWrapper>
)
